import { render, staticRenderFns } from "./CustomerLogo.vue?vue&type=template&id=79018f00&scoped=true"
import script from "./CustomerLogo.vue?vue&type=script&lang=js"
export * from "./CustomerLogo.vue?vue&type=script&lang=js"
import style0 from "./CustomerLogo.vue?vue&type=style&index=0&id=79018f00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79018f00",
  null
  
)

export default component.exports